import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';


interface SvgMenuArrowIconProps {
  height: number,
  width?: number,
  color?: string,
}

const SvgMenuArrowIcon = ({
  height, width, color, ...props 
}: SvgMenuArrowIconProps) => {
  const theme = useContext(ThemeContext);
  const fill = color ?? theme.colors.dark;
  return (
    <svg width={width ?? ((height * 3) / 2)} height={height} viewBox="0 0 15 10" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.583 0L7.5 5.917 13.417 0 15 1.583l-7.5 7.5-7.5-7.5L1.583 0z"
        fill={fill}
      />
    </svg>
  );
};

export default SvgMenuArrowIcon;
